import axios from 'axios'

export default {
    test(state, payload)
    {
        console.log(payload);
    },
    AllGradDegrees(state, payload){
      axios.get(state.root + 'g_programs?per_page=50&filter[orderby]=date&order=asc&orderby=slug')
        .then(function (response) {
          //console.log(response.data[0].acf.ncu_media)
          state.gradDegrees = []
          let q = response.data
          console.log(q)
          for(let i =0; i < q.length; i++){
            let k = {}
            k.title = q[i].title['rendered']
            k.articleType = q[i].type
            k.slug = q[i].slug
            k.id = q[i].id
            k.date_created = q[i].date
            k.degree_name = q[i].acf.degree_name
            k.masters_arts = q[i].acf.masters_arts
            k.department = q[i].acf.department
            k.masters_of_business = q[i].acf.masters_of_business
            k.masters_of_science = q[i].acf.masters_of_science
            k.masters_of_ph = q[i].acf.masters_of_ph
            k.doctorial = q[i].acf.doctorial

            k.job_application = q[i].acf.job_application

            state.gradDegrees.push(k)
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getDegree(state, payload){

        axios.get(state.root + payload.degreeType + '/?slug=' + payload.degreeName)
          .then(function (response) {
            //console.log(response.data[0].acf.ncu_media)
            state.viewDegree = []
            let q = response.data[0]
            console.log(q)
            //for(let i =0; i < 10; i++){
              let k = {}
              k.title = q.title['rendered']
              k.articleType = q.type
              k.slug = q.slug
              k.id = q.id
              k.date_created = q.date
              k.cover1 = q.acf.cover_image_1
              k.cover2 = q.acf.cover_image_2
              k.cover3 = q.acf.cover_image_3
              k.degree = q.acf.degree_name
              k.isprovisional = q.acf.isprovisional
              k.degreetype = q.acf.degree_type
              k.degreequote = q.acf.degree_quote
              k.emphasis_and_concentration = q.acf.emphasis_and_concentrations
              k.program_length = q.acf.program_length_
              k.degree_do_for_me = q.acf.degree_do_for_me.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")
              k.matriculation_requirements = q.acf.matriculation_requirements.replace(/(<ul[^>]+?>|<ul>|<\/ul>)/img, "").replace(/(<li[^>]+?>|<li>)/img, "").replace(/(<\/li>)/img, "*")
              k.provisional_requirements = q.acf.provisional_requirements.replace(/(<ul[^>]+?>|<ul>|<\/ul>)/img, "").replace(/(<li[^>]+?>|<li>)/img, "").replace(/(<\/li>)/img, "*")
              k.what_you_leave_with = q.acf.what_you_leave_with.replace(/(<ul[^>]+?>|<ul>|<\/ul>)/img, "").replace(/(<li[^>]+?>|<li>)/img, "").replace(/(<\/li>)/img, "*");
              k.emphasis = q.acf.emphasis
              k.department = q.acf.department
              if(q.acf.bachelor_arts === true ){
                k.degree_area = 'Bachelors of Arts'
              } else if(q.acf.bachelor_science === true){
                k.degree_area = 'Bachelors of Science'
              }else if(q.acf.associate_arts === true){
                k.degree_area = 'Associate of Arts'
              }else if(k.degree_area = 'Associate of Science'){
                k.degree_area = 'Associate of Science'
              }

              state.viewDegree.push(k)
            //}
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    getGradDegree(state, payload){

      axios.get(state.newRootUrl + '?slug=' + payload.degreeName)
        .then(function (response) {
          //console.log(response.data[0].acf.ncu_media)
          state.viewGradDegree = []

          state.viewGradDegree = response.data
          //}
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AllExtensionDegrees(state, payload){
        axios.get(state.root + 'extensiondegrees?per_page=50&filter[orderby]=date&order=asc&orderby=slug') //?per_page=10
            .then(function (response) {
                //console.log(response.data[0].acf.ncu_media)
                state.extensionDegrees = []
                let q = response.data
                console.log(q)
                for(let i =0; i < q.length; i++){
                    let k = {}
                    k.title = q[i].title['rendered']
                    k.slug = q[i].slug
                    k.id = q[i].id
                    k.day = q[i].acf.day
                    k.evening = q[i].acf.evening
                    k.online = q[i].acf.online
                    k.degree_name = q[i].acf.degree_name
                    k.eastern = q[i].acf.eastern_campus
                    k.western = q[i].acf.western_campus
                    k.asc = q[i].acf.asc
                    k.bsc = q[i].acf.bsc
                    k.ba = q[i].acf.ba
                    k.aa = q[i].acf.masters
                    k.phd = q[i].acf.phd

                    state.extensionDegrees.push(k)
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    /*AllExtensionDegrees(state, payload){
      axios.get(state.root + 'extensiondegrees?per_page=50&filter[orderby]=date&order=asc&orderby=slug') //?per_page=10
      //axios.get(state.strapiApi + 'extension-offerings') //?per_page=10

        .then(function (response) {
            console.log()
          //console.log(response.data[0].acf.ncu_media)
          state.extensionDegrees = []
          let q = response.data
          console.log(q)
          for(let i =0; i < q.length; i++){
              console.log(i)
            state.extensionDegrees.push(q[i])
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },*/
    AllUndergradDegrees(state, rootState){
      axios.get(state.root + 'u_programs?per_page=50&filter[orderby]=date&order=asc&orderby=slug') //?per_page=10
        .then(function (response) {
          //console.log(response.data[0].acf.ncu_media)
          state.undergradDegrees = []
          let q = response.data
          console.log(q)
          for(let i =0; i < q.length; i++){
            let k = {}
            k.title = q[i].title['rendered']
            k.articleType = q[i].type
            k.slug = q[i].slug
            k.id = q[i].id
            k.date_created = q[i].date
            k.degree_name = q[i].acf.degree_name
            k.associate_arts = q[i].acf.associate_arts
            k.associate_science = q[i].acf.associate_science
            k.bachelor_arts = q[i].acf.bachelor_arts
            k.bachelor_science = q[i].acf.bachelor_science
            k.emphasis = q[i].acf.emphasis
            k.department = q[i].acf.department
            console.log(k.bachelor_degree)
            k.job_application = q[i].acf.job_application

            state.undergradDegrees.push(k)
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    GetGraduateDegrees(state){
        axios.get('https://cdn.contentful.com/spaces/4tchdr4earqv/environments/master/entries?access_token=bPj_mN-cZmGQeJ7iXiLKIf6tejHAhGkuw9KU3TF7als&content_type=graduatePrograms') //?per_page=10
            .then(function (response) {
                console.log(response.data.items);
                state.GradPrograms = response.data.items;
            })
    },
    GetCurrentPrograms(state){
        axios({
            method: "GET",
            url: "https://aeorion.ncu.edu.jm/api/AeorionData/GetCurrentPrograms",
            auth: {
                username: process.env.VUE_APP_AEORION_USERNAME,
                password: process.env.VUE_APP_AEORION_PASSWORD
            }
        }).then(res =>{
            console.log(res.data);
            state.programmeResults = res.data;
        }).catch(error =>{
            console.log(error.message)
        })
    },
    GetGraduatePrograms(state, payload){
        console.log(payload)
        axios({
            method: "GET",
            url: 'https://manage.ncu.edu.jm/wp-json/data/graduate-programs?slug=' + payload.data,
        }).then(r => {
            console.log(r)
            state.SingleProgramResult = r.data[0]
        })
    }
}
